<ng-container *ngIf="!initialDataLoading">
  <h2 class="db-clone-installation__title">{{ 'text_cloneYourWebsite' | dbText }}</h2>

  <form class="db-clone-installation__body" [formGroup]="cloneInstallationForm" id="form" (ngSubmit)="validateAndProceed()">
    <!-- submit form with Enter -->
    <button [disabled]="loading" type="submit" style="display:none">hidden submit</button>

    <h4 class="db-clone-installation__section-title mb10"><b>{{ 'text_chooseEnvironmentClone' | dbText }}</b></h4>
    <h4 class="db-clone-installation__section-title text-overflow-ellipsis mb20">
      <b>{{ 'text_website' | dbText }}: </b><span [innerHTML]="originalDomain"></span>
    </h4>

    <div class="ds-input-wrap static mb28">
      <ds-dropdown [dsDropdownOptions]="websiteEnvOptions" formControlName="env"
                   [dsDropdownDisabled]="websiteEnvOptions[1].value === null"
                   [dsDropdownLabel]="'text_websiteInstallWebsiteEnv' | dbText"></ds-dropdown>
    </div>

    <div class="separator"></div>

    <h4 class="db-clone-installation__section-title mb20"><b>{{ 'text_selectSubdomainDataCenter' | dbText }}</b></h4>

    <div class="ds-input-wrap static mb28">
      <span class="ds-input-label">{{ 'text_installWebsiteDialogTitle' | dbText }}</span>
      <div class="db-clone-installation__body-subdomain">
        <input type="text" class="ds-input mr20" maxlength="56"
               [class.error]="formSubmitted && cloneInstallationForm?.get('subdomain')?.errors"
               placeholder="*subdomain" formControlName="subdomain">
          <span class="db-domain-link"
                [dsTooltip]="'.'+configHostname"
                [dsTooltipColor]="'black'"
                [hostClass]="'cover-all'"
                [dsTooltipAlign]="'left'"
                [dsTooltipPosition]="'top'"
                [dsTooltipSize]="'small'"
                [dsTooltipVisible]="shouldShowHostnameTooltip">
          .{{configHostname}}</span>
      </div>
      <span *ngIf="formSubmitted && cloneInstallationForm?.get('subdomain')?.errors" class="ds-input-error-msg"
            [innerHTML]="cloneInstallationForm?.get('subdomain')?.errors['required'] ?
            'This field is required.':
            cloneInstallationForm?.get('subdomain')?.errors?.pattern ? ('text_fillFieldAllowedLetters' | dbText) :
            cloneInstallationForm?.get('subdomain')?.errors?.taken ? cloneInstallationForm?.get('subdomain')?.errors?.taken
            : ''"></span>
      <span class="ds-input-desc">{{ 'text_subDomainDescription' | dbText }}</span>

    </div>

    <div class="ds-input-wrap static mb28">
      <ds-dropdown [dsDropdownOptions]="regionOptions" formControlName="region"
                   [dsDropdownDisabled]="userSubscription?.type === UserSubscriptionCategory.DedicatedVM"
                   [dsDropdownLabel]="('text_regionDescription' | dbText)"
                   dsDropdownPosition="top"></ds-dropdown>
    </div>

    <div class="db-clone-installation__footer ds-hide-desktop" [ngClass]="{'db-flex-end': userSubscription?.isDedicatedVM}">
      <div class="db-clone-installation__footer-sites-count" *ngIf="!userSubscription?.isDedicatedVM">
        <p>{{ 'text_hostedSites' | dbText }}</p>
        <b>{{hostedWebsitesCount}} {{ 'text_of' | dbText }} {{hostedWebsitesLimit}}</b>
      </div>
      <div class="db-clone-installation__btn-wrap">
        <button class="ds-btn-blue" [disabled]="loading" form="form" value="Submit" type="submit">
          <span *ngIf="!loading">{{ 'text_cloneBtn' | dbText }}</span>
          <db-loading-circular-spinner *ngIf="loading"></db-loading-circular-spinner>
        </button>
      </div>
    </div>

  </form>

  <div class="db-clone-installation__footer ds-hide-mobile" [ngClass]="{'db-flex-end': userSubscription?.isDedicatedVM}">
    <div class="db-clone-installation__footer-sites-count" *ngIf="!userSubscription?.isDedicatedVM">
      <p>{{ 'text_hostedSites' | dbText }}</p>
      <b>{{hostedWebsitesCount}} of {{hostedWebsitesLimit}}</b>
    </div>
    <div class="db-clone-installation__btn-wrap">
      <button class="ds-btn-blue" [disabled]="loading" form="form" value="Submit" type="submit">
        <span *ngIf="!loading">{{ 'text_cloneBtn' | dbText }}</span>
        <db-loading-circular-spinner *ngIf="loading"></db-loading-circular-spinner>
      </button>
    </div>
  </div>
</ng-container>

<db-loading-screen *ngIf="initialDataLoading" [pageBlocker]="true"></db-loading-screen>
